import { Component, Input, OnInit, Output, EventEmitter, OnDestroy } from '@angular/core';
import { DialogService } from '../../../services/modal-dialogs';
import { SweetAlertService } from 'ng2-cli-sweetalert2';
import { ssApiService } from '../../../services/ss-api.service';
import { LogsResponse } from '../../../models/ss-api/responses/logs.response';
import { LicenseManager } from '../../../managers/License.manager';
import { KeyValuePair } from '../../../models/KeyValuePair';
import { NoteTypes, Note } from '../../../models/domain/note';
import { NoteManagerConstructor } from '../../../managers/note.manager';
import { NoteManager } from '../../../managers/note.manager';
import { MemberEventsService } from '../../../services/member.events.service';
import { AdminLogItem, AdminLogItemArray } from '../../../models/domain/admin.log.item';
import { Subscription } from 'rxjs';
import { EntityChangedArgs } from '../../../managers/manager.base';
import { MemberLogItemArray } from '../../../models/domain/member.log.item';
import { WindowSettings } from '../../../../app/services/window-dialogs/window.settings';
import { WindowTypes, WindowActionTypes } from '../../../../app/services/window-dialogs/window.event';
import { WindowService } from '../../../../app/services/window-dialogs/window.service';
import { Router } from '../../../../../node_modules/@angular/router';
import { SortBot } from '../../../../app/helpers/sort';
import { NoteDetailsDialog } from '../../../dialogs/note.details/note.details.dialog';
import { AuthenticationLogItemArray } from '@models/domain/authentication.log.item';
import { UpdateLogItemArray } from '@models/domain/update.log.item';

@Component({
    selector: 'member-logs',
    templateUrl: './member.logs.component.html',
    styleUrls: ['./member.logs.component.scss']
})
export class MemberLogsComponent implements OnInit, OnDestroy {
    @Input('IsBusy') IsBusy: boolean;
    @Input('MemberID') MemberID: number;
    @Input('Logs') Logs: LogsResponse;
    @Output('onRefresh') onRefresh: EventEmitter<string> = new EventEmitter();
    @Output() refreshEvent = new EventEmitter();

    private licenseManager: LicenseManager = new LicenseManager();
    private licenseManagerSubscription: Subscription;
    private noteChangeSubscription: Subscription;

    activeTab: string = "AdminLogs";

    LogSearch: String;

    adminResultRows: number = 25;
    adminFirstResult: number = 0;
    adminLastResult: number = 24;

    memberResultRows: number = 25;
    memberFirstResult: number = 0;
    memberLastResult: number = 24;

    authenticationResultRows: number = 25;
    authenticationFirstResult: number = 0;
    authenticationLastResult: number = 24;

    updateResultRows: number = 25;
    updateFirstResult: number = 0;
    updateLastResult: number = 24;

    constructor(private api: ssApiService, private dialogService: DialogService, private sweetAlertService: SweetAlertService, private memberEvents: MemberEventsService, private windowService: WindowService, private router: Router) { }

    sortByAdminDate() { this.Logs.AdminLogs = SortBot.SortAuto<AdminLogItemArray>(this.Logs.AdminLogs, 'DateTimeCreated') }
    sortByAdminSubject() { this.Logs.AdminLogs = SortBot.SortAuto<AdminLogItemArray>(this.Logs.AdminLogs, 'Subject') }
    sortByAdminDescription() { this.Logs.AdminLogs = SortBot.SortAuto<AdminLogItemArray>(this.Logs.AdminLogs, 'Description') }
    sortByAdminType() { this.Logs.AdminLogs = SortBot.SortAuto<AdminLogItemArray>(this.Logs.AdminLogs, 'LogType') }
    sortByAdminKey() { this.Logs.AdminLogs = SortBot.SortAuto<AdminLogItemArray>(this.Logs.AdminLogs, 'LicenseKey') }
    sortByAdminAdmin() { this.Logs.AdminLogs = SortBot.SortAuto<AdminLogItemArray>(this.Logs.AdminLogs, 'AdminFullName') }

    sortByMemberDate() { this.Logs.MemberLogs = SortBot.SortAuto<MemberLogItemArray>(this.Logs.MemberLogs, 'DateTimeCreated') }
    sortByMemberSubject() { this.Logs.MemberLogs = SortBot.SortAuto<MemberLogItemArray>(this.Logs.MemberLogs, 'Subject') }
    sortByMemberDescription() { this.Logs.MemberLogs = SortBot.SortAuto<MemberLogItemArray>(this.Logs.MemberLogs, 'Description') }
    sortByMemberType() { this.Logs.MemberLogs = SortBot.SortAuto<MemberLogItemArray>(this.Logs.MemberLogs, 'LogType') }
    sortByMemberKey() { this.Logs.MemberLogs = SortBot.SortAuto<MemberLogItemArray>(this.Logs.MemberLogs, 'LicenseKey') }
    sortByMemberAdmin() { this.Logs.MemberLogs = SortBot.SortAuto<MemberLogItemArray>(this.Logs.MemberLogs, 'AdminFullName') }

    sortByAuthDate() { this.Logs.AuthenticationLogs = SortBot.SortAuto<AuthenticationLogItemArray>(this.Logs.AuthenticationLogs, 'DateTimeCreated') }
    sortByAuthIP() { this.Logs.AuthenticationLogs = SortBot.SortAuto<AuthenticationLogItemArray>(this.Logs.AuthenticationLogs, 'IP') }
    sortByAuthResult() { this.Logs.AuthenticationLogs = SortBot.SortAuto<AuthenticationLogItemArray>(this.Logs.AuthenticationLogs, 'Result') }
    sortByAuthIsNotEnabled() { this.Logs.AuthenticationLogs = SortBot.SortAuto<AuthenticationLogItemArray>(this.Logs.AuthenticationLogs, 'IsNotEnabled') }
    sortByAuthIsLocked() { this.Logs.AuthenticationLogs = SortBot.SortAuto<AuthenticationLogItemArray>(this.Logs.AuthenticationLogs, 'IsLocked') }
    sortByAuthTimeconditionNotMatched() { this.Logs.AuthenticationLogs = SortBot.SortAuto<AuthenticationLogItemArray>(this.Logs.AuthenticationLogs, 'TimeconditionNotMatched') }
    sortByAuthIpFilter() { this.Logs.AuthenticationLogs = SortBot.SortAuto<AuthenticationLogItemArray>(this.Logs.AuthenticationLogs, 'IpFilter') }

    sortByUpdateDate() { this.Logs.UpdateLogs = SortBot.SortAuto<UpdateLogItemArray>(this.Logs.UpdateLogs, 'DateTimeCreated') }
    sortByUpdateKey() { this.Logs.UpdateLogs = SortBot.SortAuto<UpdateLogItemArray>(this.Logs.UpdateLogs, 'LicenseKey') }
    sortByUpdateHardwareScore() { this.Logs.UpdateLogs = SortBot.SortAuto<UpdateLogItemArray>(this.Logs.UpdateLogs, 'HardwareScore') }
    sortByUpdateAllowed() { this.Logs.UpdateLogs = SortBot.SortAuto<UpdateLogItemArray>(this.Logs.UpdateLogs, 'UpdateAllowed') }

    ngOnInit() {
        this.licenseManagerSubscription = this.licenseManager.OnIsBusyChanged.subscribe(isBusy => { this.IsBusy = isBusy });
        this.noteChangeSubscription = this.memberEvents.onNoteChanged.subscribe(args => this.onNoteChanged(args));
    }

    ngOnDestroy() {
        this.licenseManagerSubscription.unsubscribe();
        this.noteChangeSubscription.unsubscribe();
    }

    onNoteChanged(args: EntityChangedArgs<Note>) {

        let ID = Note.GetNoteTypeValue(args.Original.NoteTypeList, NoteTypes.AdminLog);

        if (ID == 0)
            return;

        // search for license in designers
        let adminLog = this.Logs.AdminLogs.find(x => x.ID == ID);
        if (adminLog != undefined) {
            // we found the designer license
            adminLog.HasNotes = true;
            return;
        }

        // search for memberLog
        let memberLog = this.Logs.MemberLogs.find(x => x.ID == ID);
        if (memberLog != undefined) {
            // we found the own license
            memberLog.HasNotes = true
        }

    }

    onLicenseClick(license: AdminLogItem) {
        this.IsBusy = true;
        let manager = new LicenseManager()
        manager.OnDataLoaded.subscribe(response => {
            this.IsBusy = false;
        });
        manager.Load(license.LicenseKey, true);
        manager.OnChangesSaveResponse.subscribe(response => {
            this.onRefresh.emit('');
        })
    }

    onInvoiceClick(invoiceID: number) {

    }

    EditNote(myItem: any) {

        let type = new KeyValuePair<NoteTypes, number>(NoteTypes.AdminLog, myItem.ID);

        if (myItem.HasNotes) {
            // load

            let noteData = new NoteManagerConstructor(myItem.ID);
            noteData.NoteType = type;
            noteData.RelationInfo = myItem.ID;
            noteData.RelationObject = myItem;
            noteData.ShowAfterLoad = true;
            this.ShowNoteDialog(noteData);
            // let noteManager = new NoteManager(noteData);
        } else {
            // add new
            this.AddNote(myItem);
        }

    }

    AddNote(myItem: AdminLogItem) {
        // add new

        let type = new KeyValuePair<NoteTypes, number>(NoteTypes.AdminLog, myItem.ID);
        let noteData = new NoteManagerConstructor();
        noteData.MemberID = myItem.Member_ID;
        noteData.NoteType = type;
        noteData.RelationInfo = myItem.Subject;
        noteData.RelationObject = myItem;
        noteData.IsAddNote = true;
        this.ShowNoteDialog(noteData);
        // let noteManager = new NoteManager(noteData);
    }

    ShowNoteDialog(noteData: NoteManagerConstructor) {
        let note = new NoteManager(noteData);
        let options = {
            width: 1240,
            height: 650
        }
        let disposable = this.dialogService.addDialog(NoteDetailsDialog, { noteManager: note }, options).subscribe(response => {
            disposable.unsubscribe();
        })
    }

    ShowNoteWindow(noteData: NoteManagerConstructor) {
        let windowSettings = new WindowSettings();
        windowSettings.Height = 900;
        windowSettings.Width = 1240;

        let result = this.windowService.OpenWindow<NoteManagerConstructor>(WindowTypes.Note, noteData, windowSettings);

        let subscription = result.onEvent.subscribe(event => {

            if (event.ActionType == WindowActionTypes.Saved) {
                this.onNoteChanged(event.Data);
            }

            if (event.ActionType == WindowActionTypes.Close)
                subscription.unsubscribe();

        });
    }

    paginateAdminLogs(e) {
        this.adminFirstResult = e.page * e.rows;
        this.adminLastResult = this.adminFirstResult + e.rows;
    }

    paginateMemberLogs(e) {
        this.memberFirstResult = e.page * e.rows;
        this.memberLastResult = this.memberFirstResult + e.rows;
    }

    paginateAuthenticationLogs(e){
        this.authenticationFirstResult = e.page * e.rows;
        this.authenticationLastResult = this.memberFirstResult + e.rows;
    }

    paginateUpdateLogs(e){
        this.updateFirstResult = e.page * e.rows;
        this.updateLastResult = this.memberFirstResult + e.rows;
    }

}
